import { render } from "./ApiGetLoadWithAddMaster.vue?vue&type=template&id=1a4ee15c&ts=true"
import script from "./ApiGetLoadWithAddMaster.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiGetLoadWithAddMaster.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/api/ApiGetLoadWithAddMaster.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a4ee15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a4ee15c', __exports__)) {
    api.reload('1a4ee15c', __exports__)
  }
  
  module.hot.accept("./ApiGetLoadWithAddMaster.vue?vue&type=template&id=1a4ee15c&ts=true", () => {
    api.rerender('1a4ee15c', render)
  })

}


export default __exports__